
import { Directive, Input, Renderer2, ElementRef, SimpleChanges, OnChanges, HostListener, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { EnvSetting } from '../utils/env-setting';
import { GlobalSetting } from '../common-services/global-setting.service';

@Directive({
    selector: 'img[af-item-status-icon]'
})
export class AfItemStatusDirective implements OnChanges, OnInit {
    @Input('data-code') iconId: number;
    @Input('data-type') imgType: string | null = null;
    @Input('data-src') imgSrc: string | null = null;
    @Input('data-fallback') fallback: string | null = null;

    private readonly _noImage = '../../../../assets/no-image-icon.png';
    private readonly _loading = '/assets/images/loading.svg';
    constructor(private readonly http: HttpClient,
        private readonly globalSetting: GlobalSetting,
        private readonly elementRef: ElementRef,
        private readonly renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document) {
    }
    ngOnInit(): void {
        this.elementRef.nativeElement.src = this._loading;
        this.renderer.setAttribute(this.elementRef.nativeElement, 'img-code', this.iconId?.toString());
        this.loadIcon();
    }

    @HostListener('error')
    loadFallback() {
        this.elementRef.nativeElement.src = this.fallback ?? this._noImage;
    }

    ngOnChanges(_changes: SimpleChanges): void {
        this.loadIcon();
    }

    loadIcon() {
        const element = this.elementRef.nativeElement;
        if (!element) {
            return;
        }
        if (this.imgType?.toUpperCase() == "ITEM_STATUS") {
            const iconId = this.iconId;
            const existImg = this.globalSetting.itemStatusIcons.find(x => x.iconId == iconId);
            if (iconId == null || iconId == undefined) {
                element.src = this._noImage;
            }
            else if (existImg?.imgData) {
                this.reloadIcon(iconId, existImg.imgData);
            }
            else if (iconId >=0 && !existImg) {
                this.globalSetting.itemStatusIcons.push({ iconId: iconId, imgData: '' });
                let headers = new HttpHeaders();
                headers = headers.set('Accept', 'application/json')
                    .set('Content-Type', 'application/json');
                this.http.get(`${EnvSetting.ItemStatusIconUrl}/${iconId}`, { headers }).subscribe((res: any) => {
                    if (res) {
                        this.globalSetting.itemStatusIcons.filter(x => x.iconId == iconId).forEach(el => {
                            el.imgData = res;
                        });
                        this.reloadIcon(iconId, res);
                    }
                    else{
                        this.reloadIcon(iconId, this._noImage);              7
                    }
                },(_err)=>{
                    this.reloadIcon(iconId, this._noImage);
                });
            }
            else{
                this.reloadIcon(iconId, this._noImage);
            }
        }
        else {
            this.renderer.setAttribute(element, 'src', this.imgSrc ?? this._noImage);
        }
    }
    reloadIcon(iconId: number, imgData: string){
        const icons = this.document.querySelectorAll(`[img-code="${iconId}"]`);
        icons.forEach((img) => {
            this.renderer.setAttribute(img, 'src', imgData);
        });
    }
}